import { SZ_THEME } from './common/sz';
import { DM_THEME } from './common/datamill';
import { GE_THEME } from './common/default';
import { SHOP_THEME } from './common/shop';
import { COMMON_LINE_SYMBOL } from './common/base';
export default {
  default: {
    color: GE_THEME.GE_COLOR,
    legend: GE_THEME.GE_LEGEND,
    tooltip: GE_THEME.GE_TOOLTIP,
    xAxis: {
      splitLine: GE_THEME.GE_SPLITLINE,
      axisPointer: GE_THEME.GE_AXISPOINTER,
      axisLabel: GE_THEME.GE_AXISLABEL,
      axisTick: {
        show: false
      },
      axisLine: {
        show: false
      }
    },
    yAxis: {
      splitLine: GE_THEME.GE_SPLITLINE,
      axisLabel: GE_THEME.GE_AXISLABEL,
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      }
    },
    series: {
      symbol: COMMON_LINE_SYMBOL,
      symbolSize: 12,
      lineStyle: {
        width: 2
      },
      itemStyle: {
        opacity: 0
      },
      emphasis: {
        lineStyle: {
          width: 2
        },
        itemStyle: {
          opacity: 1,
          borderColor: 'rgba(255, 255, 255, 0.85)',
          borderWidth: 6
        }
      },
      animation: false
    }
  },
  datamill: {
    color: DM_THEME.DM_COLOR,
    legend: DM_THEME.DM_LINE_LEGEND,
    tooltip: DM_THEME.DM_TOOLTIP,
    xAxis: {
      axisLabel: DM_THEME.DM_AXISLABEL,
      axisPointer: DM_THEME.DM_AXISPOINTER,
      axisTick: {
        show: false
      },
      axisLine: {
        show: false
      }
    },
    yAxis: {
      axisLabel: DM_THEME.DM_AXISLABEL,
      splitLine: DM_THEME.DM_SPLITLINE,
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      }
    },
    series: {
      symbol: COMMON_LINE_SYMBOL,
      symbolSize: 9,
      itemStyle: {
        borderWidth: 3,
        borderColor: '#FFFFFF'
      },
      emphasis: {
        lineStyle: {
          width: 2
        },
        itemStyle: {
          opacity: 1,
          borderColor: '#FFFFFF',
          borderWidth: 3
        }
      }
    }
  },
  sz: {
    color: SZ_THEME.SZ_COLOR,
    legend: SZ_THEME.SZ_LEGEND,
    tooltip: SZ_THEME.SZ_TOOLTIP,
    xAxis: {
      axisLine: SZ_THEME.SZ_AXISLINE,
      axisLabel: SZ_THEME.SZ_AXISLABEL,
      splitLine: SZ_THEME.SZ_SPLITLINE,
      axisPointer: SZ_THEME.SZ_AXISPOINTER,
      // 隐藏x轴刻度
      axisTick: {
        show: false
      }
    },
    yAxis: {
      axisLabel: SZ_THEME.SZ_AXISLABEL,
      splitLine: SZ_THEME.SZ_SPLITLINE,
      // 隐藏y轴轴线
      axisLine: {
        show: false
      },
      // 隐藏y轴刻度
      axisTick: {
        show: false
      }
    },
    series: {
      symbol: COMMON_LINE_SYMBOL,
      symbolSize: 8,
      lineStyle: {
        width: 2
      },
      itemStyle: {
        opacity: 0
      },
      emphasis: {
        focus: 'series',
        lineStyle: {
          width: 2
        },
        itemStyle: {
          opacity: 1,
          borderColor: 'rgba(255, 255, 255, 0.85)',
          borderWidth: 3
        }
      }
    }
  },
  shop: {
    color: SHOP_THEME.SHOP_COLOR,
    legend: SHOP_THEME.SHOP_LEGEND,
    tooltip: SHOP_THEME.SHOP_TOOLTIP,
    xAxis: {
      axisLine: SHOP_THEME.SHOP_AXISLINE,
      axisLabel: SHOP_THEME.SHOP_AXISLABEL,
      splitLine: SHOP_THEME.SHOP_SPLITLINE,
      axisPointer: SHOP_THEME.SHOP_AXISPOINTER,
      // 隐藏x轴刻度
      axisTick: {
        show: false
      }
    },
    yAxis: {
      axisLabel: SHOP_THEME.SHOP_AXISLABEL,
      splitLine: SHOP_THEME.SHOP_SPLITLINE,
      // 隐藏y轴轴线
      axisLine: {
        show: false
      },
      // 隐藏y轴刻度
      axisTick: {
        show: false
      }
    },
    series: {
      symbol: 'none',
      lineStyle: {
        width: 2
      },
      emphasis: {
        lineStyle: {
          width: 2
        }
      }
    }
  }
};